import "../carousel-buttons.scss"
import IconNext from "../../../../../../components/icons/icon-next/icon-next";

interface ISlideNextButton {
    swiper: any
}

const SlideNextButton: React.FC<ISlideNextButton> = ({swiper}) => {
    return (
        <button className="carousel-next-button" onClick={() => swiper.slideNext()}>
            <div className="icon-carousel">
                <IconNext color={'var(--color-neutral-1-white)'}/>
            </div>
        </button>
    );
}

export default SlideNextButton;